import { GameEvents } from "../utils/Types";

export class NumberCounter extends Phaser.GameObjects.BitmapText {
  private counterTween?: Phaser.Tweens.Tween;
  private prefix: string = "";
  private suffix: string = "";

  private upAnimationScale: number = 1;
  private downAnimationScale: number = 1;

  private upAnimationColor: number = 0x8de35d;
  private downAnimationColor: number = 0xe82337;

  private immediate: boolean = false;
  private showPositiveSign: boolean = false;

  constructor(
    scene: Phaser.Scene,
    private currentValue: number = 0,
    private readonly numberUpdateEvent?: GameEvents,
  ) {
    super(scene, 0, 0, "fnt_paintBasic", `${currentValue}`, 64);

    if (this.numberUpdateEvent) {
      this.scene.game.events.on(
        this.numberUpdateEvent,
        this.OnNumberUpdateEvent,
        this,
      );
    }
  }

  public SetPrefix(prefix: string): this {
    this.prefix = prefix;
    this.updateText();
    return this;
  }

  public SetSuffix(suffix: string): this {
    this.suffix = suffix;
    this.updateText();
    return this;
  }

  public SetAnimationScale(upValueScale: number, downValueScale: number): this {
    this.upAnimationScale = upValueScale;
    this.downAnimationScale = downValueScale;
    return this;
  }

  public SetAnimationColor(upValueColor: number, downValueColor: number): this {
    this.upAnimationColor = upValueColor;
    this.downAnimationColor = downValueColor;
    return this;
  }

  public SetImmediate(immediate: boolean): this {
    this.immediate = immediate;
    return this;
  }

  public SetShowPositiveSign(show: boolean): this {
    this.showPositiveSign = show;
    this.updateText();
    return this;
  }

  public OnNumberUpdateEvent(value: number): void {
    const animationDuration = 500;

    this.counterTween?.stop();

    if (
      (this.upAnimationScale !== 1 && this.currentValue < value) ||
      (this.downAnimationScale !== 1 && this.currentValue > value)
    ) {
      this.scene.tweens.add({
        targets: this,
        scale:
          this.currentValue < value
            ? this.upAnimationScale
            : this.downAnimationScale,
        duration: animationDuration * 0.5,
        ease: "Power2",
        yoyo: true,
      });
    }

    if (this.immediate) {
      this.currentValue = value;
      this.updateText();
      return;
    }

    if (this.currentValue > value) {
      this.setTint(this.downAnimationColor);
    } else if (this.currentValue !== value) {
      this.setTint(this.upAnimationColor);
    }

    this.counterTween = this.scene.tweens.addCounter({
      from: this.currentValue,
      to: value,
      duration: animationDuration,
      ease: "Power2",
      onUpdate: (tween) => {
        const value = tween.getValue();
        if (!value) return;
        const roundedValue = Math.round(tween.getValue()!);
        this.currentValue = roundedValue;
        this.setText(
          `${this.prefix}${this.showPositiveSign && this.currentValue > 0 ? "+" : ""}${roundedValue}${this.suffix}`,
        );
      },
      onComplete: () => {
        this.currentValue = value;
        this.updateText();
        this.clearTint();
      },
    });
  }

  private updateText(): void {
    this.setText(
      `${this.prefix}${this.showPositiveSign && this.currentValue > 0 ? "+" : ""}${this.currentValue}${this.suffix}`,
    );
  }
}
